// extracted by mini-css-extract-plugin
module.exports = {"cta":"AboutCTA_cta___Bv29","inner":"AboutCTA_inner__u8ur5","heading":"AboutCTA_heading__txlqJ","text":"AboutCTA_text__ydY8Y","button":"AboutCTA_button__zkQPZ"};